import { populateWorkloadFields } from './populateWorkloadFields';
export var provisionWorkloads = function (workloads) {
    var allWorkloadsArray = workloads.coreAndSegmentApps.concat(workloads.nonCoreAndSegmentApps);
    // TODO: handle MSA workloads
    populateWorkloadFields(allWorkloadsArray);
    var provisionedWorkloads = allWorkloadsArray.filter(function (workload) { return !!workload.Url; });
    provisionedWorkloads === null || provisionedWorkloads === void 0 ? void 0 : provisionedWorkloads.forEach(function (provisionedWorkload) {
        if (!provisionedWorkload.IsThirdParty) {
            // Remove 'Shell' prefix from Id to form the AppId required by the Pin API on Shell Shim.
            provisionedWorkload.AppId = provisionedWorkload.Id.slice(5);
            // Hard code the Shell first party collector ID since that is all we deal with here.
            provisionedWorkload.CollectorId = 'FirstParty';
        }
    });
    return provisionedWorkloads;
};
//# sourceMappingURL=provisionWorkloads.js.map